import {
  trim, isEmpty, take, filter, every, slice, values, includes,
} from 'lodash';
import {
  NUMBER_OF_SCANNER_FIELDS,
  SCANNER_DELIMITER, SCANNER_FIELD_NAME_BY_POSITION,
  SCANNER_PREFIX,
  SCANNER_SUFFIX,
} from '@/constants/scanner';
import TransactionDto from '@/interfaces/transaction.dto';
import { EUR_TO_HRK } from '@/constants/currency';
import { Currency } from '@/enums/currency.enum';

export default function parseScannerInput(scannerInput: string): TransactionDto {
  if (!(scannerInput.startsWith(SCANNER_PREFIX) && scannerInput.endsWith(SCANNER_SUFFIX))) {
    throw new Error('Invalid scanner input!');
  }

  const scannerInputStripped = scannerInput.slice(1, scannerInput.length - 1);
  let scannerInputLines = scannerInputStripped.split(SCANNER_DELIMITER);

  const isEverySecondLineEmpty = every(scannerInputLines, (line, idx) => {
    if (idx % 2 === 1) {
      return isEmpty(line);
    }

    return true;
  });

  if (isEverySecondLineEmpty) {
    // This is Chrome, take every 2nd line
    scannerInputLines = filter(scannerInputLines, (line, index) => index % 2 === 0);
  }

  const scannerFields = take(
    scannerInputLines.map(trim),
    NUMBER_OF_SCANNER_FIELDS,
  );

  const ccy = scannerFields[SCANNER_FIELD_NAME_BY_POSITION.CCY];
  let amount = Number(scannerFields[SCANNER_FIELD_NAME_BY_POSITION.AMT]);

  if (!includes(values(Currency), ccy)) {
    throw new Error('Invalid currency!');
  }

  if (ccy === Currency.HRK) {
    amount = Math.round(amount / EUR_TO_HRK);
  }

  return {
    amount,
    ccy: 'EUR',
    hrvhub: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.HRVHUB],
    dbtrNm: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.DBTRNM],
    dbtrAddr: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.DBTRADDRESS],
    dbtrLocation: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.DBTRLOCATION],
    crdtrNm: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.CRDTRNM],
    crdtrAddr: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.CRDTRADDRESS],
    crdtrLocation: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.CRDTRLOCATION],
    crdtrIban: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.IBAN],
    model: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.MODEL],
    ref: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.CALL_NUM],
    code: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.CODE],
    info: scannerFields[SCANNER_FIELD_NAME_BY_POSITION.INFO],
  };
}

export function parseManagementRef(ref: string) {
  const result = /^\d{4}-(\d{2})(\d{9})-\d(\d{4})$/.exec(ref);

  if (!result) {
    return null;
  }

  const [month, invoiceNumber, year] = slice(result, 1);

  return {
    month,
    year,
    invoiceNumber,
  };
}

export function parseHeatingRef(ref: string) {
  const result = /^\d{4}-(\d{4})(\d{2})-(\d{4})$/.exec(ref);

  if (!result) {
    return null;
  }

  const [invoiceNumber, month, year] = slice(result, 1);

  return {
    month,
    year,
    invoiceNumber,
  };
}
